/** Marketing landing for Tcards Mini Website (in-app route). */
export const MINI_WEBSITE_HOME = '/miniwebsite';

/** Main Tcards.org homepage (logo click target). */
export const TCARDS_HOME_URL = 'https://www.tcards.org';
